import $ from 'jquery';
import processor from './processors';

$(function () {
    /**
     * Template function
     *
     * @param   {[type]}  strings  [strings description]
     * @param   {[type]}  keys     [keys description]
     *
     * @return  {[type]}           [return description]
     */
    function template(html, data) {
        return eval('`' + html + '`');
    }

    $(document).on('click', '.add-more', function (e) {
        e.preventDefault();

        let me = $(this),
            tpl = $(me.data('template')).get(0).innerHTML,
            insertBefore = $(me.data('before')),
            elementsSelector = me.data('elements'),
            data = me.get(0).dataset;

        data.index = $(elementsSelector).length;
        let element = $(template(tpl, data));
        processor.run(element);
        $(insertBefore).before(element);

        if (e.callback) {
            e.callback.apply(element);
        }
    })

    $(document).on('keyup', ':input[data-add-more]', function (e) {
        if (!$(e.target).val()) {
            return;
        }
        
        let me = $(this),
            elementsSelector = me.data('add-more-elements'),
            elements = $(elementsSelector);

        if (me.closest(elementsSelector).get(0) !== elements.last().get(0)) {
            return;
        }
        
        let tpl = $(me.data('add-more')).get(0).innerHTML,
            insertBefore = $(me.data('add-more-before')),
            data = me.get(0).dataset;

        data.index = elements.length;
        let element = $(template(tpl, data));
        processor.run(element);
        $(insertBefore).before(element);

        if (e.callback) {
            e.callback.apply(element);
        }
    });
});